import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import './LandingPage.css';
import BackgroundWrapper from '../components/BackgroundWrapper';
import star from '../features/attackSurface/assets/star.png';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  const handleScanForFree = () => {
    navigate('/upload');
  };

  const handleLearnMore = () => {
    window.open('https://www.deepkeep.ai');
  };

  const handleTermsOfUse = () => {
    window.open('https://www.deepkeep.ai/terms-of-service');
  };

  const handlePrivacyPolicy = () => {
    window.open('https://www.deepkeep.ai/privacy-policy');
  };

  return (
    <BackgroundWrapper>
      <div className="landing-container">
        <Header />

        {/* Main Content */}
        <main className="landing-main">
          <div className="landing-badge">
             <img src={star} alt="" className='star-icon'/> Free Agentic Attack Surface Assessment
          </div>

          <h1 className="landing-title">
            Get Your Agent Risk Report
          </h1>

          <p className="landing-subtitle">
            Discover your AI agent's security attack surface, reveal its exploitable weaknesses, and get clear,
            prioritized recommendations to mitigate them.
          </p>

          <div className="landing-buttons">
            <button
              onClick={handleScanForFree}
              className="landing-button-primary"
            >
              Scan for Free
            </button>
            <button
              onClick={handleLearnMore}
              className="landing-button-secondary"
            >
              Learn About Us
            </button>
          </div>

          {/* Footer Section */}
          <div className="landing-footer">
            <hr className="landing-footer-separator" />
            <div className="landing-footer-row">
              <span className="landing-footer-left">
                © 2026 DeepKeep. All rights reserved.
              </span>
              <div className="landing-buttons-2">
                <button
                  onClick={handleTermsOfUse}
                  className="terms-of-use-btn"
                >
                  Terms of Use
                </button>
                <button
                  onClick={handlePrivacyPolicy}
                  className="privacy-policy-btn"
                >
                  Privacy Policy
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
      
    </BackgroundWrapper>
  );
};

export default LandingPage;